// ── Column Configuration (Matches server epm_tests status enum) ───────────────
export const COLUMN_CONFIG = [
    { key: 'IDEAS',       label: 'Ideas' },
    { key: 'PRIORITISED', label: 'Prioritised' },
    { key: 'PLANNING',    label: 'Planning' },
    { key: 'BUILD_QA',    label: 'Build & QA' },
    { key: 'SCHEDULED',   label: 'Scheduled' },
    { key: 'LIVE',        label: 'Live' },
    { key: 'ANALYSING',   label: 'Analysing' },
    { key: 'CONCLUDED',   label: 'Concluded' },
];

export const COLUMN_ORDER = COLUMN_CONFIG.map((c) => c.key);
export const COLUMN_LABELS = Object.fromEntries(COLUMN_CONFIG.map((c) => [c.key, c.label]));

